<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <h4 class="title text-center">{{ address }}</h4>
      <div id="map" class="map"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GoogleMapsLoader from "google-maps";

export default {
  name: "ContactMapPage",
  computed: {
    ...mapGetters(["getManageOrganizationInfo"]),
    lat() {
      return this.getManageOrganizationInfo.latitude;
    },
    lng() {
      return this.getManageOrganizationInfo.longitude;
    },
    markerName() {
      return this.getManageOrganizationInfo.name;
    },
    address() {
      return this.getManageOrganizationInfo.address;
    }
  },
  methods: {
    initRegularMap() {
      const myLatlng = new window.google.maps.LatLng(this.lat, this.lng);
      const mapOptions = {
        zoom: 17,
        center: myLatlng,
        scrollwheel: true
      };

      const map = new window.google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

      const marker = new window.google.maps.Marker({
        position: myLatlng,
        title: this.markerName
      });

      marker.setMap(map);
    }
  },
  mounted() {
    GoogleMapsLoader.load(google => {
      this.initRegularMap(google);
    });
  }
};
</script>

<style scoped lang="scss">
.card-map {
  min-height: 350px;
  .map {
    height: 300px;
    width: 100%;
  }
}
</style>
